import React, { useEffect, useCallback, useRef } from "react";
import "./infra.css";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSchoolStatsData } from "../../redux/thunks/dashboardThunk";
import { fetchSchoolStatsDataYear } from "../../redux/thunks/dashboardThunk";
import { fetchArchiveServicesSchoolData } from "../../redux/thunks/archiveServicesThunk";
import { useExportToExcel } from "../../pdfAndExcellUtils/pdfAndExcellUtils";

import {
  state_gov_mgt_code,
  gov_aided_mgt_code,
  pvt_uaided_mgt_code,
  ctrl_gov_mgt_code,
  other_mgt_code,
  pr_sch_code,
  upr_pr_code,
  hr_sec_code,
  sec_sch_code,
  pre_pr_sch_code,
  selectedDYear,
  nationalWiseName,
  stateWiseName,
  districtWiseName,
  district,
  blockWiseName,
  block,
  generateTextContent,
  foundational_preparatory,
  middle,
  secondary,
  excelStyles
} from "../../constants/constants";
import allreportsdata from "../../json-data/allreports.json";
import allReportsHindidata from "../../json-data/allReportsHindi.json";
import { ScrollToTopOnMount } from "../Scroll/ScrollToTopOnMount";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-material.css";
import groupByKey from "../../utils/groupBy";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { allFilter } from "../../redux/slice/schoolFilterSlice";
import { initialFilterSchoolData } from "../../constants/constants";
import HC_more from "highcharts/highcharts-more";
import FilterDropdown3016 from "../Home/filter/FilterDropdown3016";
import { useLocation, useSearchParams } from "react-router-dom";
import { GlobalLoading } from "../GlobalLoading/GlobalLoading";
import { categoryMappings as categoryMappingsOriginal } from "../../constants/constants";
import { removeAllDistrict } from "../../redux/thunks/districtThunk";
import { removeAllBlock } from "../../redux/thunks/blockThunk";
import { handleActiveTabs } from "../../redux/slice/headerSlice";
import { useTranslation } from "react-i18next";
import FilterDropdownCommom358 from "../Home/filter/FilterDropdownCommon358";
import { handleMissingData } from "../../utils/handleMissingData";
import satyamevaimg from "../../assets/images/satyameva-jayate-img.png";
import udise from "../../assets/images/udiseplu.jpg";
import nic from "../../assets/images/nic-sm-logo.png";

import useReportOverallLocationSum from "../../CustomHook/useReportOverallLocationSum"
import Footer from "../Header/Footer";


require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/accessibility")(Highcharts);
require("highcharts/modules/export-data.js")(Highcharts);
require("highcharts/highcharts-more")(Highcharts);
require("highcharts/modules/treemap")(Highcharts);
require("highcharts/modules/treegraph")(Highcharts);
HC_more(Highcharts);
const isMobile = window.matchMedia("(max-width: 767px)").matches;

export default function InfrastructureReport1005() {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const [queryParameters] = useSearchParams();
  const id = queryParameters.get("id");
  const type = queryParameters.get("type");
  const location = useLocation();
  const queryString = window.location.hash.substring(1);
  const urlParams = new URLSearchParams(queryString.split("?")[1]);
  const paramValue = urlParams.get("type");
  const school_data = useSelector((state) => state.school);
  const school_data_valueTypes =
    useSelector((state) => state?.schoolStats) || {};
  const school_data_Years =
    useSelector((state) => state?.schoolStatsYear) || [];
  const school_data_valueType =
    useSelector((state) => state?.schoolStats?.data?.data?.[0]) || {};
  const school_data_Year =
    useSelector((state) => state?.schoolStatsYear?.data?.data) || [];

    const [isNEP, setIsNEP] = useState(true); // true => NEP, false => Pre NEP
  const categoryMappings = {};
  for (const [key, value] of Object.entries(categoryMappingsOriginal)) {
    categoryMappings[key] = t(`categories.${key}`);
  }

  const updatedSchoolData = school_data?.data?.data?.map((school) => {
    let updatedSchool = { ...school }; // Create a copy of the school object
    
    console.log('NEPPPPPP')
    console.log(isNEP)
    // if(isNEP){
      if (categoryMappings.hasOwnProperty(school.schCategoryDesc)) {
      updatedSchool.schCategoryDesc = categoryMappings[school.schCategoryDesc];
    }
  
    if (updatedSchool.schCategoryCode === "1" || updatedSchool.schCategoryCode === "12") {
      if(isNEP) updatedSchool.schCategoryDesc = "Foundational and Preparatory";
      else if(updatedSchool.schCategoryCode === "1" && !isNEP) updatedSchool.schCategoryDesc = "Primary(1-5)";
      
    }
     else if (updatedSchool.schCategoryCode === "2") {
      updatedSchool.schCategoryDesc = "Middle (1-8)";
    } 
    else if (updatedSchool.schCategoryCode === "3") {
      updatedSchool.schCategoryDesc = "Secondary (1-12)";
    }
    else if (updatedSchool.schCategoryCode === "4") {
      updatedSchool.schCategoryDesc = "Middle (6-8)";
    }
    else if (updatedSchool.schCategoryCode === "5") {
      updatedSchool.schCategoryDesc = "Secondary (6-12)";
    }
    else if (updatedSchool.schCategoryCode === "6") {
      updatedSchool.schCategoryDesc = "Secondary (1-10)";
    }
    else if (updatedSchool.schCategoryCode === "7") {
      updatedSchool.schCategoryDesc = "Secondary (6-10)";
    }
    else if (updatedSchool.schCategoryCode === "8") {
      updatedSchool.schCategoryDesc = "Secondary (9-10)";
    }
    else if (updatedSchool.schCategoryCode === "9") {
      updatedSchool.schCategoryDesc = "Secondary (1-12)";
    }
    else if (updatedSchool.schCategoryCode === "10") {
      updatedSchool.schCategoryDesc = "Secondary (9-12)";
    }
    else if (updatedSchool.schCategoryCode === "11") {
      updatedSchool.schCategoryDesc = "Secondary (11-12)";
    }
  
    return updatedSchool;
    // }
    // else{
    //    if (categoryMappings.hasOwnProperty(school.schCategoryDesc)) {
    //   return {
    //     ...school,
    //     schCategoryDesc: categoryMappings[school.schCategoryDesc],
    //   };
    // }
    // return school;
    // }
    
  });

  const schoolFilter = useSelector((state) => state.schoolFilter);
  const headerData = useSelector((state) => state.header);
  // const local_state = window.localStorage.getItem("state_wise");
  const [local_state, setLocalStateName] = useState("All India/National");
  const [local_district, setLocalDistrictName] = useState("District");
  const [local_block, setLocalBlockName] = useState("Block");
  const local_year = window.localStorage.getItem("year");
  const stateName = localStorage.getItem("state");
  const filterObj = structuredClone(schoolFilter);
  const [report, setReport] = useState(null);
  const [gridApi, setGridApi] = useState();
    const gridApiRef = useRef(null);
  const [arrGroupedData, setArrGroupedData] = useState([]);
  const [activeTab, setActiveTab] = useState(type);
  const [isCheckFilter, setIsCheckFilter] = useState(false);
  const [isScrollComplete, setIsScrollComplete] = useState(false);
  dispatch(handleActiveTabs(activeTab));
  const [customChange, setCustomChange] = useState([]);
  
  const [groupKeys, setGroupKeys] = useState({
    schCategoryBroad: false,
    schCategoryDesc: false,
    schLocationDesc: false,
  });

  useEffect(() => {
    dispatch(removeAllDistrict());
    dispatch(removeAllBlock());
  }, []);
  useEffect(() => {
    window.localStorage.setItem("map_state_name", "All India/National");
    window.localStorage.setItem("state", "All India/National");
    window.localStorage.setItem("state_wise", "All India/National");
    window.localStorage.setItem("map_district_name", "District");
    window.localStorage.setItem("district", "District");
    window.localStorage.setItem("block", "Block");
  }, []);

  useEffect(() => {
    setLocalStateName(localStorage.getItem("state"));
    setLocalStateName(localStorage.getItem("state_wise"));
    setLocalStateName(localStorage.getItem("map_state_name"));

    setLocalDistrictName(localStorage.getItem("map_district_name"));
    setLocalBlockName(localStorage.getItem("block"));
  }, [filterObj, headerData.activeTab]);

  const [enabledScType, setEnabledSchType] = useState(false);
  const [enabledSchLocation, setEnabledSchLocations] = useState(false);
  const [showTransposed, setShowTransposeds] = useState(false);
  const [gridRefreshKey, setGridRefreshKey] = useState(0);
  const [showTransposedMgts, setShowTransposedMgts] = useState(false);
  const [cat, setCat] = useState("active");
  const [cat_Details, setCatDetail] = useState("");
  const [sch_type, setSchTypes] = useState("");
  const [ur, setUR] = useState("");
  const [cloneUr, setCloneUR] = useState("");
  const [cloneSchtype, setCloneSchTypes] = useState("");
  const [multiCat, setMultiCats] = useState("multibtn");
  const [data, setData] = useState([]);
  const [cloneFilterDatas, setCloneFilterDatas] = useState([]);
  const [customColumnNames, setCustomColumns] = useState("");
  const [customColumnName, setCustomColumn] = useState("");
  const [pinnedBottomRowDataByRows, setPinnedBottomRowDataByRow] = useState([]);

  const totalLabel = t("total");

  const filter_query_by_location =
    (local_state === "All India/National" &&
      groupKeys.schCategoryBroad &&
      groupKeys.schCategoryDesc) ||
    local_state === "State Wise" ||
    local_district === "District Wise" ||
    local_block === "Block Wise";
  const [columns, setColumn] = useState([
    {
      headerName: "Serial Number",
      field: "Serial Number",
      hide: true,
      suppressColumnsToolPanel: true,
      suppressFiltersToolPanel: true,
    },
    {
      headerName: "Location",
      field: "regionName",
      hide: false,
    },
    {
      headerName: t("school_type"),
      field: "schTypeDesc",
      hide: false,
    },
    {
      headerName: "School Category(Broad)",
      field: "schCategoryBroad",
      suppressColumnsToolPanel: true,
      hide: true,
    },
    {
      headerName: "School Category(Detailed)",
      field: "schCategoryDesc",
      suppressColumnsToolPanel: true,
      hide: true,
    },

    {
      headerName: "Total No. of Schools",
      field: "totSch",
      cellClass: 'ag-right-aligned-cell'
    },
  ]);


    useEffect(() => {
      if (!showTransposed) {
        const appendedObj = {};
        const removefirstTwoColumns = columns.slice(2);
        removefirstTwoColumns.forEach((item) => {
          if (item.field === customColumnNames) {
            appendedObj[item.field] = "Total";
          } else if (item.field === customColumnNames) {
            appendedObj[item.field] = "Total";
          } else {

            appendedObj[item.field] = calculateTotal(item.field);
          }
        });
        setTimeout(() => {
            
          setCustomChange([appendedObj]) 
        },10)
      }
    }, [columns]);


  // caluculate horizontal total
  const getLastTrueToShowTotal = () => {
    const lastTrueKey = Object.keys(groupKeys).reduce((lastKey, key) => {
      if (groupKeys[key]) {
        return key;
      }
      return lastKey;
    }, null);
    return lastTrueKey;
  };

  // caluculate Vertical  total

  function calculateTotal(fieldName) {
    if (!arrGroupedData) return 0;
    return arrGroupedData.reduce(
      (total, row) => total + parseFloat(row[fieldName] || 0),
      0
    );
  }

  function calculateTotalOverall(data,fieldName) {
    if (!data) return 0;
    return data.reduce(
      (total, row) => total + parseFloat(row[fieldName] || 0),
      0
    );
  }

  // Taking the both reports data condition wise for language change
  useEffect(() => {
    const reportsData =
      i18n.language === "hi" ? allReportsHindidata : allreportsdata;

    for (const category in reportsData) {
      const foundReport = reportsData[category].find(
        (report) => report.id === parseInt(id)
      );
      if (foundReport) {
        setReport(foundReport);
        break;
      }
    }
  }, [id, i18n.language]);

  useEffect(() => {
    if (paramValue === "table") {
      dispatch(allFilter(initialFilterSchoolData));
      dispatch(fetchArchiveServicesSchoolData(initialFilterSchoolData));
    } else if (paramValue === "graph") {
      initialFilterSchoolData.valueType = 2;
      dispatch(allFilter(initialFilterSchoolData));
      dispatch(fetchSchoolStatsData(initialFilterSchoolData));
      initialFilterSchoolData.valueType = 1;
      dispatch(allFilter(initialFilterSchoolData));
      dispatch(fetchSchoolStatsDataYear(initialFilterSchoolData));
    }
  }, [paramValue, i18n.language]);

  useEffect(() => {
    const allFalse = Object.values(groupKeys).every((value) => value === false);
    if (allFalse) {
      schoolLocationRows();
    } else {
      handleCustomKeyInAPIResponse();
      multiGroupingRows();
    }

    gridApi?.columnApi?.api.setColumnVisible("regionName");
  }, [school_data?.data?.data]);
  useEffect(() => {
    const allFalse = Object.values(groupKeys).every((value) => value === false);
    if (allFalse) {
      schoolLocationRows();
    } else {
      multiGroupingRows();
    }
  }, [groupKeys, data]);
  useEffect(() => {
    //  /----------If any of the column is showing by row[disable school type/Urban/Rural]-------------/
    if (showTransposed || showTransposedMgts) {
      setEnabledSchType(true);
      setEnabledSchLocations(true);
      if (ur === "active") {
        setUR("");
        setCloneUR("active");
      }
      if (sch_type === "active") {
        setCloneSchTypes("active");
        setSchTypes("");
      }
    } else {
      if (cloneUr === "active") {
        setUR("active");
        setCloneUR("");
      }
      if (cloneSchtype === "active") {
        setSchTypes("active");
        setCloneSchTypes("");
      }
      setEnabledSchType(false);
      setEnabledSchLocations(false);
    }
    // /-----end here------/
  }, [showTransposed, showTransposedMgts]);
  // useEffect(() => {
  //   multiGroupingRows();
  //   if (showTransposed) {
  //     switchColumnsToRow(false, true);
  //   }
  // }, [data]);
  useEffect(() => {
    if (showTransposed) {
      switchColumnsToRow(false, true);
    }
  }, [cloneFilterDatas, groupKeys, data]);
  useEffect(() => {
    if (showTransposed || showTransposedMgts) {
      const appendedObj = {};
      columns.forEach((item) => {
        if (item.field === customColumnNames) {
          appendedObj[item.field] = "";
        } else if (item.field === customColumnName) {
          appendedObj[item.field] = t("total");
        } else {
          appendedObj[item.field] = calculateTotal(item.field);
        }
      });
      setPinnedBottomRowDataByRow([appendedObj]);
    }
  }, [columns]);
  const [defColumnDefs] = useState({
    flex: 1,
    minWidth: 150,
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
    // filter: true,
    autoHeaderHeight: true,
    headerClass: "headerStyle"
  });

  const countTotalPinnedWithRightVisible = (visibleArr,obj) => {
    let total = 0;
    for (const key in obj) {
     for(const key2 in visibleArr){
      if(visibleArr[key2]?.colId == key){
      const value = obj[key];
      if(key !="Serial Number" && key !="Overall"){
      if (Number.isInteger(value)) {
        total += value;
      }
    }
  }
    }
  }
    return total;
  };

  function onColumnVisible(event) {
    setTimeout(function() {
      

    const columnId = event?.column?.colId;
    const visible = event.visible;
     const gridApi1 = gridApiRef.current;
    
    const allData = [];

    const visibleColumns = gridApi.api.getAllDisplayedColumns();
    gridApi1.forEachNodeAfterFilter((node) => {
      if(node.data['School Type'] !='Overall'){
    allData.push(node.data);
      }
  });

  const newArr = allData.map((item, idx) => {

    return {
      ...item,
      Overall: countTotalPinnedWithRightVisible(visibleColumns,item),
      "Serial Number": idx + 1,
    };
  });
  setArrGroupedData(newArr);

  const appendedObj = {};
  visibleColumns.forEach((item) => {
    if (item.colId === customColumnNames) {
      appendedObj[item.colId] = "";
    } else if (item.colId === customColumnName) {
      appendedObj[item.colId] = t("total");
    } else {
      appendedObj[item.colId] = calculateTotalOverall(newArr,item.colId);
    }
  });
  setPinnedBottomRowDataByRow([appendedObj]);




    if (columnId === "schCategoryBroad") {
      setGroupKeys((prev) => ({
        ...prev,
        schCategoryBroad: visible,
      }));
      setCat(() => (visible ? "active" : ""));
      setMultiCats("multibtn");
    }
    if (columnId === "schCategoryDesc") {
      setGroupKeys((prev) => ({
        ...prev,
        schCategoryDesc: visible,
      }));
      setCatDetail(() => (visible ? "active" : ""));
      setMultiCats("multibtn");
    }

    // if (columnId === "schLocationDesc") {
    //   setGroupKeys((prev) => ({
    //     ...prev,
    //     schLocationDesc: visible,
    //   }));
    //   setUR(() => (visible ? "active" : ""));
    // }



  let pinnedBottomRowDatas =
  (anyGroupKeyTrue || local_state !== "All India/National") &&
    (anyGroupKeyTrue ||
      local_state === "State Wise" ||
      anyGroupKeyTrue ||
      local_district === "District Wise" ||
      anyGroupKeyTrue ||
      local_block === "Block Wise")
    ? showTransposed || showTransposed
      ? pinnedBottomRowDataByRows
      : pinedBottomRowDatas
    : [];
  setCustomChange(pinnedBottomRowDatas);

}, 100);

  }

  const onGridReady = (params) => {
    gridApiRef.current = params.api;
    setColumnVisibility(groupKeys);
    setGridApi(params);
  };

  const setColumnVisibility = (keys) => {
   
    if (gridApiRef.current) {
      const gridApi = gridApiRef.current;
      Object.keys(keys).forEach((key) => {
        gridApi?.columnApi?.setColumnVisible(key, keys[key]);
      });
    }
  };

const handleCustomKeyInAPIResponse = () => {
  const arr = [];

  updatedSchoolData?.forEach((item, idx) => {
    let appendedObj = { ...item };

    if (isNEP) {
      // --- NEP logic from new file ---
      if (foundational_preparatory.includes(item.schCategoryCode)) {
        appendedObj.schCategoryBroad = "Foundational and Preparatory";
      } else if (middle.includes(item.schCategoryCode)) {
        appendedObj.schCategoryBroad = "Middle";
      } else if (secondary.includes(item.schCategoryCode)) {
        appendedObj.schCategoryBroad = "Secondary";
      }
    } else {
      // --- Pre NEP logic from old file ---
           if (pr_sch_code.includes(item.schCategoryCode)) {
        appendedObj.schCategoryBroad = "Primary";
      } else if (upr_pr_code.includes(item.schCategoryCode)) {
        appendedObj.schCategoryBroad = "Upper Primary";
      } else if (hr_sec_code.includes(item.schCategoryCode)) {
        appendedObj.schCategoryBroad = "Higher Secondary";
      } else if (sec_sch_code.includes(item.schCategoryCode)) {
        appendedObj.schCategoryBroad =  "Secondary";
      } else if (pre_pr_sch_code.includes(item.schCategoryCode)) {
        appendedObj.schCategoryBroad = "Pre-Primary";
      }
    }

    arr.push(appendedObj);
  });

  setData(arr);
};

  
useEffect(() => {
  handleCustomKeyInAPIResponse();
  const allFalse = Object.values(groupKeys).every((value) => value === false);
  if (allFalse) {
    schoolLocationRows();
  } else {
    multiGroupingRows();
  }
}, [isNEP]);

  const handleFilter = (value, e) => {
    if (value === "School Category" || value === "Cats Details") {
      if (value === "School Category") {
        if (cat === "active") {
          setCat("");
        } else {
          setCat("active");
        }
      } else {
        setCat("");
      }
      if (value === "Cats Details") {
        if (cat_Details === "active") {
          setCatDetail("");
        } else {
          setCatDetail("active");
        }
      } else {
        setCatDetail("");
      }
      if (value === "School Category") {
        if (cat === "active") {
          setMultiCats("multibtn");
        } else {
          setMultiCats("multibtn");
        }
      }
      if (value === "Cats Details") {
        if (cat_Details === "active") {
          setMultiCats("");
        } else {
          setMultiCats("multibtn");
        }
      }
    }
  };

  const handleGroupButtonClicks = (e) => {
    setGridRefreshKey((prevKey) => prevKey + 1);
    handleFilter(e);
    const updatedGroupKeys = { ...groupKeys };

    if (e === "School Category") {
      updatedGroupKeys.schCategoryBroad = true;
      updatedGroupKeys.schCategoryDesc = false;
      setCat("active");
      setCatDetail("");
    } else if (e === "Cats Details") {
      updatedGroupKeys.schCategoryDesc = true;
      updatedGroupKeys.schCategoryBroad = false;
      setCat("");
      setCatDetail("active");
    }
    setGroupKeys(updatedGroupKeys);
    const allFalse = Object.values(updatedGroupKeys).every(
      (value) => value === false
    );
    if (allFalse) {
      schoolLocationRows();
    } else {
      handleCustomKeyInAPIResponse();
      multiGroupingRows();
    }
    if (showTransposed) {
      switchColumnsToRow();
    }
  };

  const schoolLocationRows = () => {
    const primaryKeys = ["regionName"];
    const groupedData = groupByKey(updatedSchoolData, primaryKeys);
    const updatedArrGroupedData = [];
    if (groupedData && typeof groupedData === "object") {
      Object.keys(groupedData)?.forEach((item, idx) => {
        const itemsArray = groupedData[item];
        let totalSchoolsHaveElectricity = 0;
        let totalFunElectricity = 0;
        let totalSchools = 0;

        itemsArray.forEach((dataItem) => {
          totalSchoolsHaveElectricity += parseInt(dataItem.totSchElectricity);
          totalSchools += parseInt(dataItem.totSch);
          totalFunElectricity += parseInt(dataItem.totSchFuncElectricity);
        });
        const appended = {
          "Serial Number": idx + 1,
          regionName: item,
          totSch: totalSchools,
        };

        updatedArrGroupedData.push(appended);
      });
      console.log('updatedArrGroupedData', updatedArrGroupedData)
      setArrGroupedData(updatedArrGroupedData);
      setCloneFilterDatas(updatedArrGroupedData);
    }
    gridApi?.columnApi?.api.setColumnVisible("regionName", true);
    gridApi?.columnApi?.api.setColumnVisible("schCategoryBroad", true);
    gridApi?.columnApi?.api.setColumnVisible("schCategoryDesc", false);
    gridApi?.columnApi?.api.setColumnVisible("schLocationDesc", true);
  };
  const multiGroupingRows = () => {
    const primaryKeys = Object.keys(groupKeys).filter((key) => groupKeys[key]);
    if (primaryKeys.length > 0) {
      primaryKeys.push("regionName", "schTypeDesc");
      const groupedData = groupByKey(data, primaryKeys);

      const updatedArrGroupedData = [];
      if (groupedData && typeof groupedData === "object") {
        Object.keys(groupedData).forEach((item, idx) => {
          const itemsArray = groupedData[item];
          let totalSchoolsHaveElectricity = 0;
          let totalFunElectricity = 0;
          let totalSchools = 0;
          let regionName = "";
          let schTypeDesc = "";
          itemsArray.forEach((dataItem) => {
            regionName = dataItem.regionName;
            schTypeDesc = dataItem.schTypeDesc;
            totalSchoolsHaveElectricity += parseInt(dataItem.totSchElectricity);
            totalSchools += parseInt(dataItem.totSch);
            totalFunElectricity += parseInt(dataItem.totSchFuncElectricity);
          });
          const appended = {};
          primaryKeys.forEach((key, index) => {
            appended.regionName = regionName;
            appended.schTypeDesc = schTypeDesc;
            appended[key] = item.split("@")[index];
          });
          appended["Serial Number"] = idx + 1;
          appended.schTypeDesc = schTypeDesc;
          appended.totSchElectricity = totalSchoolsHaveElectricity;
          appended.totSch = totalSchools;
          appended.totSchFuncElectricity = totalFunElectricity;
          updatedArrGroupedData.push(appended);
        });
        setCloneFilterDatas(updatedArrGroupedData);
        setArrGroupedData(updatedArrGroupedData);
      }

      gridApi?.columnApi?.api.setColumnVisible(
        "schCategoryBroad",
        groupKeys.schCategoryBroad
      );
      gridApi?.columnApi?.api.setColumnVisible(
        "schCategoryDesc",
        groupKeys.schCategoryDesc
      );
      gridApi?.columnApi?.api.setColumnVisible(
        "schTypeDesc",
        groupKeys.schTypeDesc
      );
      gridApi?.columnApi?.api.setColumnVisible(
        "schLocationDesc",
        groupKeys.schLocationDesc
      );
      gridApi?.columnApi?.api.setColumnVisible("regionName");
    }
  };

  const countTotalPinnedWithRight = (obj) => {
    let total = 0;
    for (const key in obj) {
      const value = obj[key];
      if (Number.isInteger(value)) {
        total += value;
      }
    }
    return total;
  };

  const switchColumnsToRow = (e, flag = false) => {
    setShowTransposedMgts(false);
    console.log('----------------NEP', isNEP)
    if (flag || !showTransposed) {
      const arr = [];
      const uniqueLocation = new Set();
      let uniqueKeys = new Set();
      let uniqueKeys1;

      let customColumnNames = "";
      let customColumnName = "";

      if(isNEP){
             cloneFilterDatas?.forEach((row) => {
        let location = row.regionName;
        let SchType = row.schTypeDesc || "Boys";
        customColumnNames = "Location";
        customColumnName = t("school_type");
        setCustomColumns(customColumnNames);
        setCustomColumn(customColumnName);

        // Row-wise data for category
        let key;
        if (groupKeys.schCategoryBroad) {
          key = row.schCategoryBroad;
          uniqueKeys1 = new Set();
          uniqueKeys1.add("Foundational and Preparatory");
          uniqueKeys1.add("Middle");
          uniqueKeys1.add("Secondary");
        } else if (groupKeys.schCategoryDesc) {
          key = row.schCategoryDesc;
          uniqueKeys1 = new Set();
          uniqueKeys1.add("Foundational and Preparatory");
          uniqueKeys1.add("Middle (1-8)");
          uniqueKeys1.add("Middle (6-8)");
          uniqueKeys1.add("Secondary (1-10)");
          uniqueKeys1.add("Secondary (1-12)");
          uniqueKeys1.add("Secondary (6-10)");
          uniqueKeys1.add("Secondary (6-12)");
          uniqueKeys1.add("Secondary (9-12)");
          uniqueKeys1.add("Secondary (9-10)");
          uniqueKeys1.add("Secondary (11-12)");
        }

        uniqueLocation.add(location);
        key = key?.replace(/\./g, "");
        if (!uniqueKeys.has(key)) {
          uniqueKeys.add(key);
        }

        const existingDataIndex = arr.findIndex(
          (data) =>
            data[customColumnNames] === location &&
            data[customColumnName] === SchType
        );

        if (existingDataIndex !== -1) {
          arr[existingDataIndex][key] =
            (arr[existingDataIndex][key] || 0) + parseInt(row.totSch, 10);
        } else {
          let newData = {
            [customColumnNames]: location,
            [customColumnName]: SchType,
            Overall: 0,
          };
          newData[key] = parseInt(row.totSch, 10);
          arr.push(newData);
        }
      });

      uniqueKeys = new Set(uniqueKeys1);
      
      const columnHeaderss = [
        "Serial Number",
        customColumnNames,
        customColumnName,
        ...Array.from(uniqueKeys).sort((a, b) => {
          const desiredOrder = ["Foundational and Preparatory", "Middle", "Secondary", 
                                "Middle (1-8)", "Middle (6-8)","Secondary (1-10)","Secondary (6-10)","Secondary (9-10)", 
                                "Secondary (1-12)", "Secondary (6-12)",
                                 "Secondary (9-12)", "Secondary (11-12)"]; // Define your desired order
          const indexA = desiredOrder.indexOf(a);
          const indexB = desiredOrder.indexOf(b);
      
          // If not found in the desired order, keep the original order
          if (indexA === -1 && indexB === -1) return 0;
          if (indexA === -1) return 1;
          if (indexB === -1) return -1;
      
          return indexA - indexB;
        }),
        "Overall",
      ];

      setColumn(
        columnHeaderss.map((header, idx) => {
          if(header == "School Type" || header == "Urban/Rural" || header == "School Management(Broad)" || header == "School Management(Detailed)" || header == "School Category(Broad)" || header == "School Category(Detailed)"
            
          ){
            return {
              headerName: header,
              field: header?.replace(/\./g, ""),
              cellClass: idx > 1 ? "rightAligned" : "",
              filter :true,
              hide:
             (header === "School Management(Broad)" &&
                  customColumnName === "School Management(Detailed)") ||
                (header === "School Management(Detailed)" &&
                  customColumnName === "School Management(Broad)") ||
                (header === "Location" && !filter_query_by_location),
            };
          }
          else if (idx !== 0) {
            return {
              headerName: header,
              field: header?.replace(/\./g, ""),
              cellClass: idx > 1 ? "rightAligned" : "",
              hide:
                header === "Location" && !filter_query_by_location
                  ? true
                  : false,
            };
          } else {
            return {
              hide: true,
              headerName: header,
              field: header?.replace(/\./g, ""),
            };
          }
        })
      );
      }
      else if(!isNEP){
                cloneFilterDatas?.forEach((row) => {
        let location = row.regionName;
        let SchType = row.schTypeDesc || "Boys";
        customColumnNames = "Location";
        customColumnName = t("school_type");
        setCustomColumns(customColumnNames);
        setCustomColumn(customColumnName);

        // Row-wise data for category
        let key;
        if (groupKeys.schCategoryBroad) {
          key = row.schCategoryBroad;
        } else if (groupKeys.schCategoryDesc) {
          key = row.schCategoryDesc;
        }

        uniqueLocation.add(location);
        key = key?.replace(/\./g, "");
        if (!uniqueKeys.has(key)) {
          uniqueKeys.add(key);
        }

        const existingDataIndex = arr.findIndex(
          (data) =>
            data[customColumnNames] === location &&
            data[customColumnName] === SchType
        );

        if (existingDataIndex !== -1) {
          arr[existingDataIndex][key] =
            (arr[existingDataIndex][key] || 0) + parseInt(row.totSch, 10);
        } else {
          let newData = {
            [customColumnNames]: location,
            [customColumnName]: SchType,
            Overall: 0,
          };
          newData[key] = parseInt(row.totSch, 10);
          arr.push(newData);
        }
      });

      const columnHeaderss = [
        "Serial Number",
        customColumnNames,
        customColumnName,
        ...Array.from(uniqueKeys),
        "Overall",
      ];

      setColumn(
        columnHeaderss.map((header, idx) => {
          if (idx !== 0) {
            return {
              headerName: header,
              field: header?.replace(/\./g, ""),
              cellClass: idx > 1 ? "rightAligned" : "",
              hide:
                header === "Location" && !filter_query_by_location
                  ? true
                  : false,
            };
          } else {
            return {
              hide: true,
              headerName: header,
              field: header?.replace(/\./g, ""),
            };
          }
        })
      );
      }
 

      const newArr = arr.map((item, idx) => {
        return {
          ...item,
          Overall: countTotalPinnedWithRight(item),
          "Serial Number": idx + 1,
        };
      });

      setArrGroupedData(newArr);
    } else {
      setArrGroupedData(cloneFilterDatas);

      setColumn([
        {
          headerName: "Serial Number",
          field: "Serial Number",
          hide: true,
          suppressColumnsToolPanel: true,
          suppressFiltersToolPanel: true,
        },
        {
          headerName: "Location",
          field: "regionName",
          hide: !filter_query_by_location,
        },
        {
          headerName: "School Type",
          field: "schTypeDesc",
          hide: false,
        },
        {
          headerName: "School Category(Broad)",
          field: "schCategoryBroad",
          suppressColumnsToolPanel: true,
          hide: !groupKeys.schCategoryBroad,
        },
        {
          headerName: "School Category(Detailed)",
          field: "schCategoryDesc",
          suppressColumnsToolPanel: true,
          hide: !groupKeys.schCategoryDesc,
        },
        {
          headerName: "Total No. of Schools",
          field: "totSch",
          cellClass: 'ag-right-aligned-cell'
        },
      ]);
    }

    if (!flag) {
      setShowTransposeds(!showTransposed);
    }
  };

  /*------------Export data to Excel and PDF-------------*/
  const getHeaderToExport = (gridApi) => {
    const columns = gridApi.api.getAllDisplayedColumns();
    const headerCellSerialNumber = {
      text: "Serial Number",
      headerName: "S.NO.",
      bold: true,
      margin: [0, 12, 0, 0],
    };
    const headerRow = columns.map((column) => {
      const { field, headerName } = column.getColDef();
      const sort = column.getSort();
      const headerNameUppercase = field[0].toUpperCase() + field.slice(1);
      const headerCell = {
        text: headerNameUppercase + (sort ? ` (${sort})` : ""),
        headerName: headerName,
        bold: true,
        margin: [0, 12, 0, 0],
      };
      return headerCell;
    });
    headerRow.unshift(headerCellSerialNumber);
    return headerRow;
  };
  const getRowsToExport = (gridApi) => {
    const columns = gridApi.api.getAllDisplayedColumns();
    const getCellToExport = (column, node) => ({
      text: gridApi.api.getValue(column, node) ?? "",
    });
    const rowsToExport = [];
    gridApi.api.forEachNodeAfterFilterAndSort((node) => {
      const rowToExport = [];
      rowToExport.push({ text: rowsToExport.length + 1 });
      columns.forEach((column) => {
        rowToExport.push(getCellToExport(column, node));
      });
      rowsToExport.push(rowToExport);
    });
    return rowsToExport;
  };
  const getDocument = (gridApi) => {
    const headerRow = getHeaderToExport(gridApi);
    const rows = getRowsToExport(gridApi);
    const date = new Date();
    // const formattedDate = new Intl.DateTimeFormat("en-US", {
    //   year: "numeric",
    //   month: "short",
    //   day: "2-digit",
    //   hour: "2-digit",
    //   minute: "2-digit",
    //   hour12: true,
    // }).format(date);
    const formattedDate = `${date.toLocaleDateString("en-GB", {
      weekday: "long", // Full day name (e.g., Friday)
    })}, ${date.toLocaleDateString("en-GB", {
      day: "2-digit", // Day of the month (e.g., 13)
      month: "long", // Full month name (e.g., September)
      year: "numeric", // Full year (e.g., 2024)
    })}, ${date.toLocaleTimeString("en-US", {
      hour: "2-digit", // Hour (e.g., 10)
      minute: "2-digit", // Minutes (e.g., 25)
      hour12: true, // 12-hour format with AM/PM
    })}`;

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "in",
      format: [12, 20],
    });
    // Function to add header
    const addHeader = () => {
      doc.setFontSize(22);
      doc.setTextColor("black");
      doc.setFont("Helvetica", "bold");
      // doc.text("UDISE+", 0.6, 1);

      // Add the header text
      doc.text(
        "Unified District Information System for Education",
        doc.internal.pageSize.width / 2,
        0.7,
        {
          fontStyle: "bold",

          color: "black",
          align: "center",
        }
      );
      doc.setFont("Helvetica", "normal");

      doc.setFontSize(18);

      doc.text(
        "Department of School Education & Literacy, Ministry of Education, Government of India",
        doc.internal.pageSize.width / 2,
        1.1,
        {
          // fontStyle: '',
          color: "black",
          align: "center",
        }
      );

      doc.setFont("Helvetica", "bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      doc.text(`${report.report_name}`, doc.internal.pageSize.width / 2, 1.5, {
        fontSize: 12,
        fontStyle: "bold",

        color: "black",
        align: "center",
      });

      doc.setFont("Helvetica", "bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      // doc.text(`${stateName}`, doc.internal.pageSize.width / 2, 1.7, {
      //   fontSize: 12,
      //   color: "black",
      //   align: "center",
      // });

      doc.setFont("bold");

      doc.setTextColor("black");
      doc.setFontSize(20);

      doc.text(
        `Academic Year : ${local_year}`,
        doc.internal.pageSize.width / 2,
        1.9,
        {
          fontSize: 12,
          color: "black",
          align: "center",
        }
      );

      const textContent = generateTextContent(
        stateName,
        nationalWiseName,
        stateWiseName,
        local_district,
        district,
        districtWiseName,
        local_block,
        block,
        blockWiseName
      );
      if (textContent) {
        doc.text(textContent, doc.internal.pageSize.width / 2, 2.3, {
          fontSize: 12,
          color: "black",
          align: "center",
        });
      }

      // Set the margin for the image from the left
      const leftMargin = 0.1; // Margin from the left (in inches)
      const topLeftX = leftMargin; // X position from the left including margin
      const topLeftY = 0; // Y position from the top (in inches)
      const imgWidth = 2; // Image width (in inches)
      const imgHeight = 2; // Image height (in inches)

      doc.setFontSize(20);
      doc.setTextColor("blue");

      // Add the satyameva image with the specified left margin
      doc.addImage(
        satyamevaimg,
        "PNG",
        topLeftX,
        topLeftY,
        imgWidth,
        imgHeight
      );

      doc.setTextColor("blue");
      doc.setFont("bold");

      // Get page dimensions
      const pageWidthE = doc.internal.pageSize.getWidth();
      const pageHeightE = doc.internal.pageSize.getHeight();

      const imgWidthE = 2.8; // Image width (in inches)
      const imgHeightE = 1.4; // Image height (in inches)
      const marginRight = 0.7; // Right margin (in inches)

      // Calculate x position for top-right corner
      const topRightX = pageWidthE - imgWidthE - marginRight;
      const topRightY = 0.3; // Y position from the top (in inches)

      // Add the education image at the top-right corner
      doc.addImage(
        udise,
        "JPG",
        topRightX, // X position for top-right
        topRightY, // Y position for top-right
        imgWidthE,
        imgHeightE
      );

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      // Example: Draw a rectangle around the whole page
      // doc.setLineWidth(0.02); // Thicker border for the page
      // doc.rect(0.1, 0.1, pageWidth - 0.2, pageHeight - 0.2); // x, y, width, height
    };
    // Function to add footer
    const addFooter = () => {};
    const table = [];
    table.push(headerRow.map((cell) => cell.headerName));
    rows.forEach((row) => {
      table.push(row.map((cell) => cell.text));
    });
    addHeader();
    doc.autoTable({
      head: [table[0]],
      body: table.slice(1),
      theme: "grid",
      startY: 2.7,
      styles: {
        cellPadding: 0.15, // Adjust cell padding if needed
        lineColor: [0, 0, 0], // Set border color (black in this case)
        lineWidth: 0.001, // Set border width
        fillColor: [255, 255, 255], // Default background color (white)
        textColor: [0, 0, 0],
      },
      headStyles: {
        fontSize: 14, // Set the font size for the header row
        fontStyle: "bold", // Make the header text bold (optional)
        textColor: [0, 0, 0],
        cellPadding: 0.2, // Set text color for the header row
      },

      didParseCell: function (data) {
        const headerRow = getHeaderToExport(gridApi); // Get the header row

        // Get the header text for this column
        const columnHeaderText = headerRow[data.column.index]?.text;

        // Check if the current column header is "Serial Number"
        if (columnHeaderText === "Serial Number") {
          data.cell.styles.halign = "center"; // Center-align the content for "Serial Number"
        } else if (
          columnHeaderText === "RegionName" ||
          columnHeaderText === "Location" ||
          columnHeaderText === "School Type" ||
          columnHeaderText === "regionName"
        ) {
          data.cell.styles.halign = "left"; // Center-align the content for "Serial Number"
        } else {
          data.cell.styles.halign = "right";
        }
      },

      afterPageContent: addFooter,
    });

    const totalPages = doc.internal.getNumberOfPages();
    doc.page = 1;
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(14);
      doc.setFont("helvetica", "normal");
      doc.addImage(
        nic,
        "JPG",
        0.6, // X position for top-right
        11.5, // Y position for top-right
        1,
        0.3
      );
      doc.setTextColor("black");
      doc.text(
        `Page ${i} of ${totalPages}`,
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height - 0.2,
        { align: "center", color: "black" }
      );

      doc.text(
        `Report generated on : ${formattedDate}`,
        doc.internal.pageSize.width - 1,
        doc.internal.pageSize.height - 0.2,
        { fontSize: 12, align: "right", color: "black" }
      );
    }

    for (let i = 0; i < totalPages; i++) {
      doc.setPage(i + 1);
      doc.autoTable({
        startY: 3.5,
      });
    }
    return doc;
  };
  const exportToPDF = () => {
    const doc = getDocument(gridApi);
    doc.save(`${report.report_name}.pdf`);
  };

  const { exportToExcel } = useExportToExcel(gridApi, report,local_year,stateName,nationalWiseName,stateWiseName,local_district,district,districtWiseName,local_block,block,blockWiseName,generateTextContent);

  const handleExportData = (e) => {
    const { value } = e.target;
    if (value === "export_pdf") {
      exportToPDF();
    }
    if (value === "export_excel") {
      exportToExcel();
    }
    document.getElementById("export_data").selectedIndex = 0;
  };

  const pinedBottomRowDatas = [
    {
      ...(getLastTrueToShowTotal()
        ? { [getLastTrueToShowTotal()]: "Overall" }
        : { regionName: "Overall" }),
      totSch: calculateTotal("totSch"),
      totSchElectricity: calculateTotal("totSchElectricity"),
      totSchFuncElectricity: calculateTotal("totSchFuncElectricity"),
    },
  ];

  //console.log('pinedBottomRowDatas', pinedBottomRowDatas)

  useEffect(() => {
    handleGroupButtonClicks("School Category", null);
  }, []);

  useEffect(() => {
    if (cloneFilterDatas.length > 0) {
      setShowTransposeds((prevShowTransposed) => {
        if (!prevShowTransposed) {
          switchColumnsToRow(true);
        }
        return true;
      });
    }
  }, [cloneFilterDatas]);

  // chart related code

  const years = [
    // "2018-2019",
    // "2019-2020",
    // "2020-2021",
    // "2021-2022",
    "2022-2023",
    "2023-2024",
    "2024-2025"
  ];

  const boysData = school_data_Year?.map((item) => parseFloat(item.totSchoolB));
  const girlsData = school_data_Year?.map((item) =>
    parseFloat(item.totSchoolG)
  );
  const coedData = school_data_Year?.map((item) =>
    parseFloat(item.totSchoolCoed)
  );

  const upperPrimData = school_data_Year?.map((item) =>
    parseFloat(item.totSchoolUPry)
  );
  const secondaryData = school_data_Year?.map((item) =>
    parseFloat(item.totSchoolSec)
  );
  const higherSecData = school_data_Year?.map((item) =>
    parseFloat(item.totSchoolHSec)
  );
  const primaryData = school_data_Year?.map((item) =>
    parseFloat(item.totSchoolPry)
  );

  // handle by table and graph data when tab change
  useEffect(() => {
    if (headerData.activeTab === "table") {
      window.localStorage.setItem("state", "All India/National");
      window.localStorage.setItem("map_state_name", "All India/National");
      window.localStorage.setItem("map_district_name", "District");
      window.localStorage.setItem("district", "District");
      window.localStorage.setItem("block", "Block");
      window.localStorage.setItem("year", selectedDYear);
      dispatch(fetchArchiveServicesSchoolData(initialFilterSchoolData));
    }
    if (headerData.activeTab === "graph") {
      window.localStorage.setItem("state", "All India/National");
      window.localStorage.setItem("map_state_name", "All India/National");
      window.localStorage.setItem("map_district_name", "District");
      window.localStorage.setItem("district", "District");
      window.localStorage.setItem("block", "Block");
      window.localStorage.setItem("year", selectedDYear);
      initialFilterSchoolData.valueType = 2;
      dispatch(allFilter(initialFilterSchoolData));
      dispatch(fetchSchoolStatsData(initialFilterSchoolData));
      initialFilterSchoolData.valueType = 1;
      dispatch(allFilter(initialFilterSchoolData));
      dispatch(fetchSchoolStatsDataYear(initialFilterSchoolData));
    }
  }, [headerData.activeTab, i18n.language]);

  const handleScrollComplete = () => {
    setIsScrollComplete(true);
  };
  // Use `arrGroupedData` as the source data and apply the `handleMissingData` function to replace null values with "0".
  // The `handleMissingData` function is used to process data and ensure missing values are replaced,
  // which is then displayed in AG Grid using the processed data.
 
 const result=  useReportOverallLocationSum(arrGroupedData);
  const arrGroupedDataTable = handleMissingData(isCheckFilter?arrGroupedData:
           filter_query_by_location ? result : arrGroupedData,
           columns
         );

    
  const onFilterChanged = () => {
    const gridApi = gridApiRef.current;
    // gridApiRef.current.setPinnedBottomRowData(["","",""]);

        const appendedObj = {};
        const removefirstTwoColumns = columns.slice(2);
        let allData = [];
        gridApi.forEachNodeAfterFilter((node) => {
          if(node.data['School Type'] !='Overall'){
        allData.push(node.data);
          }
      });

        removefirstTwoColumns.forEach((item) => {
       
         
            if (
              item.headerName == "School Category(Broad)" ||
              item.headerName == "School Category(Detailed)" ||
              item.headerName == "School Management(Broad)" ||
              item.headerName == "School Management(Detailed)" ||
              item.headerName == "School Type" ||
              item.headerName == "Urban/Rural"
            ) {
              // fieldName=item.headerName;
              appendedObj[item.field] = "";
            } else {
              appendedObj[item.field] = filterCalculateTotal(
                allData,
                item.field
              );
            }
        });
        
        appendedObj['School Type']="Total";

        if(filter_query_by_location){
          const columnDefs = gridApi.getColumnDefs();
          setIsCheckFilter(false);
          for (let i = 0; i < columnDefs.length; i++) {
            const columnId = columnDefs[i].field;
            const filterInstancePro = gridApi.getColumnFilterInstance(columnId);
            const getValueFromFilterInstance = async () => {
              try {
                const filterInstance = await filterInstancePro;
    if(filterInstance && filterInstance?.appliedModel !=null){
                if(filterInstance?.appliedModel?.values?.length != filterInstance?.valueModel?.allValues?.size){
                  setIsCheckFilter(true);
                }
              }
              } catch (error) {
                console.error("Error fetching filter model:", error);
              }
            };
            getValueFromFilterInstance();
          }
        }

      setPinnedBottomRowDataByRow([appendedObj]);

        let pinnedBottomRowDatas =
        (anyGroupKeyTrue || local_state !== "All India/National") &&
          (anyGroupKeyTrue ||
            local_state === "State Wise" ||
            anyGroupKeyTrue ||
            local_district === "District Wise" ||
            anyGroupKeyTrue ||
            local_block === "Block Wise")
          ? showTransposed || showTransposed
            ? [appendedObj]
            : [appendedObj]
          : [];
        setCustomChange(pinnedBottomRowDatas);

      };

      // ? pinnedBottomRowDataByRows
      // : pinedBottomRowDatas
    
    
      function filterCalculateTotal(data,fieldName) {
        if (!data) return 0;
        return data.reduce(
          (total, row) => total + parseFloat(row[fieldName] || 0),
          0
        );
      }


      const anyGroupKeyTrue = Object.values(groupKeys).some(
        (value) => value === true
      );


  return (
    <>
      <ScrollToTopOnMount onScrollComplete={handleScrollComplete} />
      <section className="infrastructure-main-card p-0" id="content">
        <div className="bg-grey2 pb-0 pt-0 header-bar tab-for-graph">
          <div className="blue-strip">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-10 col-lg-10">
                  <div className="common-content text-start map-heading-map">
                    {report && (
                      <div className="common-content text-start map-heading-map d-flex align-items-center">
                        <span className="me-3">
                          {t("reports_id")} {report.id}
                        </span>
                        <h2 className="heading-sm1 mb-0 mt-0">
                          {report.report_name}
                        </h2>
                      </div>
                    )}
                  </div>
                </div>
                {activeTab !== "about" && activeTab !== "graph" && (
                  <div className="col-md-2 col-lg-2">
                    <div className="select-infra button-group-filter">
                      <div className="indicator-select">
                        <select
                          id="export_data"
                          className="form-select bg-grey2"
                          onChange={handleExportData}
                          defaultValue={""}
                        >
                          <option className="option-hide">
                            {t("download_report")}
                          </option>
                          <option value="export_pdf">
                            {t("download_report")}{" "}
                          </option>
                          <option value="export_excel">
                            {t("download_as_excel")}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="container pb-4">
            <div className="row">
              {activeTab !== "about" && activeTab !== "graph" && (
                <div className="col-md-12 col-lg-12 d-flex align-items-center">
                  <div className="tab-text-infra me-4">{t("view_data_by")}</div>
                  <ul className="nav nav-tabs mul-tab-main">
                    <li className={`nav-item ${multiCat}`}>
                      <button
                        type="button"
                        className={`nav-link dark-active1 ${cat}`}
                        onClick={(e) =>
                          handleGroupButtonClicks("School Category", e)
                        }
                      >
                        {t("school_category_board")}
                      </button>
                      <button
                        type="button"
                        className={`nav-link details-multi dark-active1 ${cat_Details}`}
                        onClick={(e) =>
                          handleGroupButtonClicks("Cats Details", e)
                        }
                      >
                        {t("detailed_view")}
                      </button>

                      {/* <button
                        type="button"
                        className={`nav-link dark-active details-multi`}
                        id="cat_row_column"
                        onClick={(e) => switchColumnsToRow()}

                      >
                        By {showTransposed ? "Column" : "Rows"}
                      </button>   */}
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="bg-grey ptb-30">
          <div className="container tab-for-graph position-relative">
            <div className="row align-items-center report-inner-tab">
              <ul className="nav nav-tabs mul-tab-main nep-position">
                <li className={`nav-item ${multiCat} national`}>
                  <button
                    type="button"
                    className={`nav-link dark-active1 ${
                      !isNEP ? "active" : ""
                    }`}
                    onClick={() => setIsNEP(false)}
                  >
                    Pre NEP
                  </button>
                  <button
                    type="button"
                    className={`nav-link details-multi dark-active1 ${
                      isNEP ? "active" : ""
                    }`}
                    onClick={() => setIsNEP(true)}
                  >
                    NEP
                  </button>
                </li>
              </ul>

              <div className="col-md-12 col-lg-12 table-text-i table-brud-card">
                {activeTab !== "about" && (
                  <h4 className="brudcrumb_heading">
                    {t("showing_result_for")}
                    <span>&nbsp;{local_state}</span>
                    <span className="material-icons-round">chevron_right</span>
                    {local_district !== "District" && (
                      <>
                        <span>{local_district}</span>
                        <span className="material-icons-round">
                          chevron_right
                        </span>
                      </>
                    )}
                    {local_block !== "Block" && (
                      <>
                        <span>{local_block}</span>
                        <span className="material-icons-round">
                          chevron_right
                        </span>
                      </>
                    )}
                    <span>{local_year}</span>
                  </h4>
                )}

                <Tabs
                  defaultActiveKey={type}
                  id="uncontrolled-tab-example"
                  // onSelect={handleTopFiveTabs}
                  className="nav-absolute"
                  onSelect={(k) => setActiveTab(k)}
                >
                  {/* <Tab eventKey="about" title={t("about")}>
                    <div className="about-card mt-4">
                      <h2 className="heading-sm2 mb-2">{t("about_us")}</h2>
                      <p>
                        {" "}
                        This report refers to a statistical analysis that
                        provides a comprehensive overview of educational
                        institutions categorized by two main criteria: type and
                        category. In this context, the types of schools are
                        delineated by the gender composition of their student
                        populations, including girls-only schools, boys-only
                        schools, and co-educational schools where both genders
                        are enrolled. Meanwhile, the category classification
                        typically pertains to the educational focus or grade
                        levels served by the schools, such as primary, upper
                        primary, higher secondary and secondary. This analysis
                        offers valuable insights into the distribution and
                        diversity of schools within a given region or
                        educational system, facilitating informed
                        decision-making processes regarding resource allocation,
                        educational planning, and efforts to ensure equitable
                        access to quality education for all students, regardless
                        of gender or other factors.
                      </p>
                      <p>
                        By analysing the number of schools across these
                        dimensions, policymakers, educators, and researchers can
                        glean valuable insights into the educational landscape.
                        This data enables them to understand the distribution of
                        educational opportunities, identify potential gaps or
                        disparities in access, and formulate targeted
                        interventions to address them. For example, it can
                        inform decisions regarding the allocation of resources,
                        the establishment of new educational facilities, or
                        initiatives aimed at promoting gender equality in
                        education.
                      </p>
                      <p>
                        Moreover, understanding the prevalence and distribution
                        of different types of schools can shed light on societal
                        preferences, cultural norms, and educational priorities
                        within a given context. For instance, regions with a
                        higher concentration of single-gender schools may
                        reflect cultural or religious preferences, while areas
                        with a prevalence of co-educational institutions may
                        prioritize inclusive learning environments.
                      </p>
                      <p>
                        In essence, the analysis of the number of schools by
                        type and category serves as a vital tool for educational
                        planning, policy formulation, and efforts to foster
                        inclusive and equitable access to education for all
                        individuals, irrespective of gender or other
                        socio-demographic factors.
                      </p>
                    </div>
                  </Tab> */}
                  <Tab
                    eventKey="table"
                    title={t("table")}
                    className="tabledata-ukkl"
                  >
                    {school_data?.isLoading && <GlobalLoading />}
                    <div
                      className="ag-theme-material ag-theme-custom-height ag-theme-quartz h-300"
                      style={{ height: 450 }}
                    >
                      <AgGridReact
                        key={gridRefreshKey}
                        rowData={arrGroupedDataTable ? arrGroupedDataTable : []}
                        getRowStyle={(params) => {
                          if (params.data.isTotalRow) {
                            return { fontWeight: "bold" }; // Apply inline bold style for totals row
                          }
                          return {}; // Default style for other rows
                        }}
                        columnDefs={columns}
                        defaultColDef={defColumnDefs}
                        onGridReady={onGridReady}
                        groupDisplayType="custom"
                        groupHideOpenParents={true}
                        onColumnVisible={onColumnVisible}
                        onFilterChanged={onFilterChanged}
                        pinnedBottomRowData={pinnedBottomRowDataByRows}
                        excelStyles={excelStyles}
                      />
                    </div>
                  </Tab>

                  <Tab disabled eventKey="graph" title={t("chart")}>
                    {school_data_valueTypes.isLoading && <GlobalLoading />}
                    {school_data_Years.isLoading && <GlobalLoading />}
                    <div className="card-box-impact tab-for-graph report-1003 mt-4">
                      <div className="row">
                        <div className="col-md-6 col-lg-6">
                          <div className="impact-box-content-education">
                            <div className="text-btn-d">
                              <h2 className="heading-sm">
                                {t("no_of_schools_by_category")} <br />{" "}
                                {t("performance_last_five_years")}
                              </h2>
                            </div>
                            <div className="piechart-box mt-4">
                              {
                                isNEP &&
                                  <HighchartsReact
                                highcharts={Highcharts}
                                options={{
                                  chart: {
                                    type: "column",
                                    marginTop: 50,
                                    events: {
                                      beforePrint: function () {
                                        this.exportSVGElements[0].box.hide();
                                        this.exportSVGElements[1].hide();
                                      },
                                      afterPrint: function () {
                                        this.exportSVGElements[0].box.show();
                                        this.exportSVGElements[1].show();
                                      },
                                    },
                                  },

                                  xAxis: {
                                    categories: years,

                                    // [
                                    //   "2018-2019",
                                    //   "2019-2020",
                                    //   "2020-2021",
                                    //   "2021-2022",
                                    //   "2022-2023"
                                    // ],
                                  },

                                  yAxis: {
                                    allowDecimals: false,
                                    min: 0,
                                    title: {
                                      text: "",
                                    },
                                  },
                                  title: {
                                    text:
                                      t("numberOfSchoolsByType") +
                                      t("performance_last_five_years"),
                                    style: {
                                      fontSize: "15px",
                                    },
                                  },
                                  tooltip: {
                                    headerFormat: "<b>{point.x}</b><br/>",
                                    pointFormat:
                                      "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
                                    pointFormatter: function () {
                                      return `<span style="color:${
                                        this.color
                                      }">\u25CF</span> ${
                                        this.series.name
                                      }: <b>${this.y.toLocaleString(
                                        "en-IN"
                                      )}</b><br/>`;
                                    },
                                  },

                                  plotOptions: {
                                    column: {
                                      stacking: "normal",
                                      minPointLength: 40,
                                      dataLabels: {
                                        enabled: true,
                                        crop: false,
                                        overflow: "none",
                                        rotation: 0,
                                        align: "center",
                                        x: -2,
                                        y: -5,
                                        style: {
                                          // color: 'black',
                                          font: "13px Arial, sans-serif",
                                          fontWeight: "600",
                                          stroke: "transparent",
                                          align: "center",
                                        },
                                        position: "top",
                                        formatter: function () {
                                          // return parseFloat(this.y).toFixed(2);
                                          return this.y.toLocaleString("en-IN");
                                        },
                                      },
                                    },
                                  },
                                  legend: {
                                    // title: {
                                    //   text: "Key",
                                    //   style: {
                                    //     fontSize: "18px",
                                    //   },
                                    // },
                                    layout: "horizontal",
                                    align: "center",
                                    verticalAlign: "bottom",
                                    itemMarginTop: 10,
                                    itemMarginBottom: 10,
                                  },
                                  credits: {
                                    enabled: false,
                                  },
                                  series: [
                                    {
                                      name: "Foundational and Preparatory",
                                      data: primaryData,
                                      color: "#F5BF55",
                                      pointWidth: 60,
                                    },
                                    {
                                      name: "Middle",
                                      data: upperPrimData,
                                      color: "#BCE263",
                                      pointWidth: 60,
                                    },
                                    {
                                      name: "Secondary",
                                      data: secondaryData,
                                      color: "#E6694A",
                                      pointWidth: 60,
                                    },
                                  ],
                                  exporting: {
                                    filename: t("noOfSchoolsByType"),
                                    csv: {
                                      columnHeaderFormatter: function (item) {
                                        if (
                                          !item ||
                                          item instanceof Highcharts.Axis
                                        ) {
                                          return t("category");
                                        }
                                        return item.name;
                                      },
                                    },
                                  },
                                }}
                                // allowChartUpdate={true}
                                immutable={true}
                              />
                              }
                              {
                                !isNEP &&
                                  <HighchartsReact
                                highcharts={Highcharts}
                                options={{
                                  chart: {
                                    type: "column",
                                    marginTop: 50,
                                    events: {
                                      beforePrint: function () {
                                        this.exportSVGElements[0].box.hide();
                                        this.exportSVGElements[1].hide();
                                      },
                                      afterPrint: function () {
                                        this.exportSVGElements[0].box.show();
                                        this.exportSVGElements[1].show();
                                      },
                                    },
                                  },

                                  xAxis: {
                                    categories: years,

                                    // [
                                    //   "2018-2019",
                                    //   "2019-2020",
                                    //   "2020-2021",
                                    //   "2021-2022",
                                    //   "2022-2023"
                                    // ],
                                  },

                                  yAxis: {
                                    allowDecimals: false,
                                    min: 0,
                                    title: {
                                      text: "",
                                    },
                                  },
                                  title: {
                                    text:
                                      t("numberOfSchoolsByType") +
                                      t("performance_last_five_years"),
                                    style: {
                                      fontSize: "15px",
                                    },
                                  },
                                  tooltip: {
                                    headerFormat: "<b>{point.x}</b><br/>",
                                    pointFormat:
                                      "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
                                    pointFormatter: function () {
                                      return `<span style="color:${
                                        this.color
                                      }">\u25CF</span> ${
                                        this.series.name
                                      }: <b>${this.y.toLocaleString(
                                        "en-IN"
                                      )}</b><br/>`;
                                    },
                                  },

                                  plotOptions: {
                                    column: {
                                      stacking: "normal",
                                      minPointLength: 40,
                                      dataLabels: {
                                        enabled: true,
                                        crop: false,
                                        overflow: "none",
                                        rotation: 0,
                                        align: "center",
                                        x: -2,
                                        y: -5,
                                        style: {
                                          // color: 'black',
                                          font: "13px Arial, sans-serif",
                                          fontWeight: "600",
                                          stroke: "transparent",
                                          align: "center",
                                        },
                                        position: "top",
                                        formatter: function () {
                                          // return parseFloat(this.y).toFixed(2);
                                          return this.y.toLocaleString("en-IN");
                                        },
                                      },
                                    },
                                  },
                                  legend: {
                                    // title: {
                                    //   text: "Key",
                                    //   style: {
                                    //     fontSize: "18px",
                                    //   },
                                    // },
                                    layout: "horizontal",
                                    align: "center",
                                    verticalAlign: "bottom",
                                    itemMarginTop: 10,
                                    itemMarginBottom: 10,
                                  },
                                  credits: {
                                    enabled: false,
                                  },
                                  series: [
                                    {
                                      name: "Primary",
                                      data: primaryData,
                                      color: "#F5BF55",
                                      pointWidth: 60,
                                    },
                                    {
                                      name: "Upper Primary",
                                      data: upperPrimData,
                                      color: "#BCE263",
                                      pointWidth: 60,
                                    },
                                    {
                                      name: "Secondary",
                                      data: secondaryData,
                                      color: "#E6694A",
                                      pointWidth: 60,
                                    },
                                    {
                                      name: "Higher Secondary",
                                      data: higherSecData,
                                      color: "#751539",
                                      pointWidth: 60,
                                    },
                                  ],
                                  exporting: {
                                    filename: t("noOfSchoolsByType"),
                                    csv: {
                                      columnHeaderFormatter: function (item) {
                                        if (
                                          !item ||
                                          item instanceof Highcharts.Axis
                                        ) {
                                          return t("category");
                                        }
                                        return item.name;
                                      },
                                    },
                                  },
                                }}
                                // allowChartUpdate={true}
                                immutable={true}
                              />
                              }
                            
                            </div>
                          </div>
                        </div>

                        {/* second value type  chart */}

                        <div className="col-md-6 col-lg-6">
                          <div className="impact-box-content-education">
                            <div className="text-btn-d">
                              <h2 className="heading-sm">
                                {t("numberOfSchoolsByType")} <br />{" "}
                                {t("performance_last_five_years")}
                              </h2>
                            </div>
                            <div className="piechart-box mt-4">
                              <HighchartsReact
                                highcharts={Highcharts}
                                options={{
                                  chart: {
                                    type: "column",
                                    marginTop: 50,
                                    events: {
                                      beforePrint: function () {
                                        this.exportSVGElements[0].box.hide();
                                        this.exportSVGElements[1].hide();
                                      },
                                      afterPrint: function () {
                                        this.exportSVGElements[0].box.show();
                                        this.exportSVGElements[1].show();
                                      },
                                    },
                                  },

                                  xAxis: {
                                    categories: years,

                                    // [
                                    //   "2018-2019",
                                    //   "2019-2020",
                                    //   "2020-2021",
                                    //   "2021-2022",
                                    //   "2022-2023"
                                    // ],
                                  },

                                  yAxis: {
                                    allowDecimals: false,
                                    min: 0,
                                    title: {
                                      text: "",
                                    },
                                  },
                                  title: {
                                    text:
                                      t("numberOfSchoolsByType") +
                                      t("performance_last_five_years"),
                                    style: {
                                      fontSize: "15px",
                                    },
                                  },
                                  tooltip: {
                                    headerFormat: "<b>{point.x}</b><br/>",
                                    pointFormat:
                                      "{series.name}: {point.y}<br/>Total: {point.stackTotal}",
                                    pointFormatter: function () {
                                      return `<span style="color:${
                                        this.color
                                      }">\u25CF</span> ${
                                        this.series.name
                                      }: <b>${this.y.toLocaleString(
                                        "en-IN"
                                      )}</b><br/>`;
                                    },
                                  },

                                  plotOptions: {
                                    column: {
                                      stacking: "normal",
                                      minPointLength: 40,
                                      dataLabels: {
                                        enabled: true,
                                        crop: false,
                                        overflow: "none",
                                        rotation: 0,
                                        align: "center",
                                        x: -2,
                                        y: -5,
                                        style: {
                                          // color: 'black',
                                          font: "13px Arial, sans-serif",
                                          fontWeight: "600",
                                          stroke: "transparent",
                                          align: "center",
                                        },
                                        position: "top",
                                        formatter: function () {
                                          // return parseFloat(this.y).toFixed(2);
                                          return this.y.toLocaleString("en-IN");
                                        },
                                      },
                                    },
                                  },
                                  legend: {
                                    // title: {
                                    //   text: "Key",
                                    //   style: {
                                    //     fontSize: "18px",
                                    //   },
                                    // },
                                    layout: "horizontal",
                                    align: "center",
                                    verticalAlign: "bottom",
                                    itemMarginTop: 10,
                                    itemMarginBottom: 10,
                                  },
                                  credits: {
                                    enabled: false,
                                  },
                                  series: [
                                    {
                                      name: t("boys"),
                                      data: boysData,
                                      color: "#57C1BB",
                                      pointWidth: 60,
                                    },
                                    {
                                      name: t("girls"),
                                      data: girlsData,
                                      color: "#BCE263",
                                      pointWidth: 60,
                                    },
                                    {
                                      name: t("co-ed"),
                                      data: coedData,
                                      color: "#E6694A",
                                      pointWidth: 60,
                                    },
                                  ],
                                  exporting: {
                                    filename: t("noOfSchoolsByType"),
                                    csv: {
                                      columnHeaderFormatter: function (item) {
                                        if (
                                          !item ||
                                          item instanceof Highcharts.Axis
                                        ) {
                                          return t("category");
                                        }
                                        return item.name;
                                      },
                                    },
                                  },
                                }}
                                // allowChartUpdate={true}
                                immutable={true}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 col-lg-6">
                          <div className="impact-box-content-education mt-3">
                            <div className="text-btn-d">
                              <h2 className="heading-sm">
                                Percentage of Schools by Type of School by
                                School Category (Broad)
                              </h2>
                            </div>

                            <div className="piechart-box mt-4">
                              {
                                isNEP &&
                                  <HighchartsReact
                                highcharts={Highcharts}
                                options={{
                                  chart: {
                                    type: "pie",
                                    marginTop: 50,
                                    events: {
                                      beforePrint: function () {
                                        this.exportSVGElements[0].box.hide();
                                        this.exportSVGElements[1].hide();
                                      },
                                      afterPrint: function () {
                                        this.exportSVGElements[0].box.show();
                                        this.exportSVGElements[1].show();
                                      },
                                    },
                                  },
                                  events: {
                                    beforePrint: function () {},
                                    afterPrint: function () {},
                                  },
                                  title: {
                                    text: t("percentageBySchoolCategory"),
                                  },
                                  tooltip: {
                                    valueSuffix: "%",
                                    valueDecimals: 2,
                                  },
                                  credits: {
                                    enabled: false,
                                  },
                                  plotOptions: {
                                    pie: {
                                      size: "100%",
                                      dataLabels: {
                                        enabled: true,
                                        distance: -40,
                                        alignTo: isMobile ? "connectors" : null,
                                        connectorShape: "crookedLine",
                                        crookDistance: "100%",
                                        formatter: function () {
                                          return "<b>" + this.point.y + "%";
                                        },
                                        style: {
                                          fontSize: "16px",
                                          textOutline: "none",
                                          opacity: 0.7,
                                        },
                                      },
                                      center: ["50%", "50%"],
                                      showInLegend: true,
                                    },
                                    series: {
                                      allowPointSelect: true,
                                      cursor: "pointer",
                                      dataLabels: [
                                        {
                                          enabled: true,
                                          distance: 20,
                                        },
                                        {
                                          enabled: false,
                                          distance: -40,
                                          format: "{point.y:.2f}%",
                                          style: {
                                            fontSize: "0.6em",
                                            textOutline: "none",
                                            opacity: 0.7,
                                          },

                                          filter: {
                                            operator: ">",
                                            property: "percentage",
                                            value: 0,
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  legend: {
                                    // title: {
                                    //   text: "Key",
                                    //   style: {
                                    //     fontSize: "18px",
                                    //   },
                                    // },
                                    layout: "horizontal",
                                    align: "center",
                                    verticalAlign: "bottom",
                                    itemMarginTop: 10,
                                    itemMarginBottom: 10,
                                  },
                                  series: [
                                    {
                                      name: t("percentage"),
                                      colorByPoint: true,
                                      data: [
                                        // {
                                        //   name: t("higher_secondary"),
                                        //   y: parseFloat(
                                        //     school_data_valueType.totSchoolHSec
                                        //   ),
                                        //   color: "#751539",
                                        // },
                                        {
                                          name: "Foundational and Preparatory",
                                          y: parseFloat(
                                            school_data_valueType.totSchoolPry
                                          ),
                                          color: "#F5BF55",
                                        },
                                        {
                                          name: t("middle"),
                                          y: parseFloat(
                                            school_data_valueType.totSchoolUPry
                                          ),
                                          color: "#BCE263",
                                        },
                                        {
                                          name: t("secondary"),
                                          y: parseFloat(
                                            school_data_valueType.totSchoolSec
                                          ),
                                          color: "#E6694A",
                                        },
                                      ],
                                    },
                                  ],
                                  exporting: {
                                    filename: t("percentageBySchoolCategory"),
                                    csv: {
                                      columnHeaderFormatter: function (item) {
                                        if (
                                          !item ||
                                          item instanceof Highcharts.Axis
                                        ) {
                                          return t("category");
                                        }
                                        return item.name;
                                      },
                                    },
                                  },
                                }}
                                // allowChartUpdate={true}
                                immutable={true}
                              />
                              }
                              {
                                !isNEP &&
                                  <HighchartsReact
                                highcharts={Highcharts}
                                options={{
                                  chart: {
                                    type: "pie",
                                    marginTop: 50,
                                    events: {
                                      beforePrint: function () {
                                        this.exportSVGElements[0].box.hide();
                                        this.exportSVGElements[1].hide();
                                      },
                                      afterPrint: function () {
                                        this.exportSVGElements[0].box.show();
                                        this.exportSVGElements[1].show();
                                      },
                                    },
                                  },
                                  events: {
                                    beforePrint: function () {},
                                    afterPrint: function () {},
                                  },
                                  title: {
                                    text: t("percentageBySchoolCategory"),
                                  },
                                  tooltip: {
                                    valueSuffix: "%",
                                    valueDecimals: 2,
                                  },
                                  credits: {
                                    enabled: false,
                                  },
                                  plotOptions: {
                                    pie: {
                                      size: "100%",
                                      dataLabels: {
                                        enabled: true,
                                        distance: -40,
                                        alignTo: isMobile ? "connectors" : null,
                                        connectorShape: "crookedLine",
                                        crookDistance: "100%",
                                        formatter: function () {
                                          return "<b>" + this.point.y + "%";
                                        },
                                        style: {
                                          fontSize: "16px",
                                          textOutline: "none",
                                          opacity: 0.7,
                                        },
                                      },
                                      center: ["50%", "50%"],
                                      showInLegend: true,
                                    },
                                    series: {
                                      allowPointSelect: true,
                                      cursor: "pointer",
                                      dataLabels: [
                                        {
                                          enabled: true,
                                          distance: 20,
                                        },
                                        {
                                          enabled: false,
                                          distance: -40,
                                          format: "{point.y:.2f}%",
                                          style: {
                                            fontSize: "0.6em",
                                            textOutline: "none",
                                            opacity: 0.7,
                                          },

                                          filter: {
                                            operator: ">",
                                            property: "percentage",
                                            value: 0,
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  legend: {
                                    // title: {
                                    //   text: "Key",
                                    //   style: {
                                    //     fontSize: "18px",
                                    //   },
                                    // },
                                    layout: "horizontal",
                                    align: "center",
                                    verticalAlign: "bottom",
                                    itemMarginTop: 10,
                                    itemMarginBottom: 10,
                                  },
                                  series: [
                                    {
                                      name: t("percentage"),
                                      colorByPoint: true,
                                      data: [
                                       
                                        {
                                          name: "Primary",
                                          y: parseFloat(
                                            school_data_valueType.totSchoolPry
                                          ),
                                          color: "#F5BF55",
                                        },
                                        {
                                          name: "Upper Primary",
                                          y: parseFloat(
                                            school_data_valueType.totSchoolUPry
                                          ),
                                          color: "#BCE263",
                                        },
                                        {
                                          name: t("secondary"),
                                          y: parseFloat(
                                            school_data_valueType.totSchoolSec
                                          ),
                                          color: "#E6694A",
                                        },
                                        {
                                          name: t("higher_secondary"),
                                          y: parseFloat(
                                            school_data_valueType.totSchoolHSec
                                          ),
                                          color: "#751539",
                                        },
                                      ],
                                    },
                                  ],
                                  exporting: {
                                    filename: t("percentageBySchoolCategory"),
                                    csv: {
                                      columnHeaderFormatter: function (item) {
                                        if (
                                          !item ||
                                          item instanceof Highcharts.Axis
                                        ) {
                                          return t("category");
                                        }
                                        return item.name;
                                      },
                                    },
                                  },
                                }}
                                // allowChartUpdate={true}
                                immutable={true}
                              />
                              }
                            
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6 col-lg-6">
                          <div className="impact-box-content-education mt-3">
                            <div className="text-btn-d">
                              <h2 className="heading-sm">
                                {t("percentageOfSchoolsByType")}
                              </h2>
                            </div>

                            <div className="piechart-box mt-4">
                              <HighchartsReact
                                highcharts={Highcharts}
                                options={{
                                  chart: {
                                    type: "pie",
                                    marginTop: 50,
                                    events: {
                                      beforePrint: function () {
                                        this.exportSVGElements[0].box.hide();
                                        this.exportSVGElements[1].hide();
                                      },
                                      afterPrint: function () {
                                        this.exportSVGElements[0].box.show();
                                        this.exportSVGElements[1].show();
                                      },
                                    },
                                  },
                                  events: {
                                    beforePrint: function () {},
                                    afterPrint: function () {},
                                  },
                                  title: {
                                    text: t("percentageOfSchoolsByType"),
                                  },
                                  tooltip: {
                                    valueSuffix: "%",
                                    valueDecimals: 2,
                                  },
                                  credits: {
                                    enabled: false,
                                  },
                                  plotOptions: {
                                    pie: {
                                      size: "100%",
                                      dataLabels: {
                                        enabled: true,
                                        distance: -40,
                                        alignTo: isMobile ? "connectors" : null,
                                        connectorShape: "crookedLine",
                                        crookDistance: "100%",
                                        formatter: function () {
                                          return "<b>" + this.point.y + "%";
                                        },
                                        style: {
                                          fontSize: "16px",
                                          textOutline: "none",
                                          opacity: 0.7,
                                        },
                                      },
                                      center: ["50%", "50%"],
                                      showInLegend: true,
                                    },
                                    series: {
                                      allowPointSelect: true,
                                      cursor: "pointer",
                                      dataLabels: [
                                        {
                                          enabled: true,
                                          distance: 20,
                                        },
                                        {
                                          enabled: false,
                                          distance: -40,
                                          format: "{point.y:.2f}%",
                                          style: {
                                            fontSize: "0.6em",
                                            textOutline: "none",
                                            opacity: 0.7,
                                          },

                                          filter: {
                                            operator: ">",
                                            property: "percentage",
                                            value: 0,
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  legend: {
                                    // title: {
                                    //   text: "Key",
                                    //   style: {
                                    //     fontSize: "18px",
                                    //   },
                                    // },
                                    layout: "horizontal",
                                    align: "center",
                                    verticalAlign: "bottom",
                                    itemMarginTop: 10,
                                    itemMarginBottom: 10,
                                  },
                                  series: [
                                    {
                                      name: t("percentage"),
                                      colorByPoint: true,
                                      data: [
                                        {
                                          name: t("boys"),
                                          y: parseFloat(
                                            school_data_valueType.totSchoolB
                                          ),
                                          color: "#57C1BB",
                                        },
                                        {
                                          name: t("girls"),
                                          y: parseFloat(
                                            school_data_valueType.totSchoolG
                                          ),
                                          color: "#BCE263",
                                        },
                                        {
                                          name: t("co-ed"),
                                          y: parseFloat(
                                            school_data_valueType.totSchoolCoed
                                          ),
                                          color: "#E6694A",
                                        },
                                      ],
                                    },
                                  ],

                                  exporting: {
                                    filename: t("percentageOfSchoolsByType"),
                                    csv: {
                                      columnHeaderFormatter: function (item) {
                                        if (
                                          !item ||
                                          item instanceof Highcharts.Axis
                                        ) {
                                          return t("category");
                                        }
                                        return item.name;
                                      },
                                    },
                                  },
                                }}
                                // allowChartUpdate={true}
                                immutable={true}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FilterDropdownCommom358 />
      <Footer />
    </>
  );
}
